const CatalogDetailDocument = (props) => {
    const {
        name, src, format, size
    } = props;

    return `
        <a href="${src}" target="_blank" class="catalog-detail-document">
            <div class="catalog-detail-document__name">${name}</div>
            <div class="catalog-detail-document__extension">
                ${format}, ${size}
            </div>
        </a>
    `;
};

export default CatalogDetailDocument;
